import React from 'react';
import {Field} from 'redux-form';
import CustomDatePicker from './CustomDatePicker.js';
import TextWithLine from './TextWithLine.js';
import RenderField from './RenderField';

const IncomeInformationForm = (props) => {
    const {member} = props;
	return	(<div>
                <div className='row'> 
                    <div className="col-sm-12 col-md-12 col-lg-12">
                        <TextWithLine value='Declaración de Ingresos Mensual'/>
                    </div>
                </div>
				<div className="row">
				    <div className="col-sm-12 col-md-3 col-lg-3">
				        <Field name={`${member}.income_date`} props={{placeholder: 'Fecha'}} component={CustomDatePicker} label="Fecha"/>
				    </div>
				    <div className="col-sm-12 col-md-3 col-lg-3">
                        <div className="form-group">
                            <Field className="form-control" name={`${member}.net_income_tax`} autoComplete="off" component={RenderField} type="number" label="Imp. Ing. Brutos" />
                        </div>
                    </div>
                    <div className="col-sm-12 col-md-3 col-lg-3">
                        <div className="form-group">
                            <Field className="form-control" name={`${member}.self_employment_payment`} autoComplete="off" component={RenderField} type="number" label={(props.selfEmploymentType === 'Monotributista' && 'Pago Monotributo') || 'Pago Responsable ins.'} />
                        </div>
                    </div>
                    <div className="col-sm-12 col-md-3 col-lg-3">
                        <div className="form-group">
                            <Field className="form-control" name={`${member}.net_income`} autoComplete="off" component={RenderField} type="number" label="Ingresos Brutos" />
                        </div>
                    </div>
				</div>
			</div>);
}

export default IncomeInformationForm;


/** WEBPACK FOOTER **
 ** ./src/components/IncomeInformationForm.js
 **/